import { useNavigate } from "react-router-dom";
import Button from "../../../components/bootstrap/Button";
import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import SubHeader, { SubHeaderLeft } from "../../../layout/SubHeader/SubHeader";
import { appMenu } from "../../../menu";
import { CommonWorkOrderDetail } from "./Common/CommonWorkOrderDetail";

const WorkOrderDetailPage = () => {

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(`../${appMenu.operations.subMenu.workOrders.path}`, {
            state: { returnedFromDetail: true }
        });
    };

    return (
        <PageWrapper title='Detalhes da ordem de serviço'>
            <SubHeader>
                <SubHeaderLeft>
                    <Button
                        color='info'
                        isLink
                        icon='ArrowBack'
                        tag='a'
                        onClick={handleBack}>
                        Voltar
                    </Button>
                </SubHeaderLeft>
            </SubHeader>
            <Page container='fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <CommonWorkOrderDetail />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default WorkOrderDetailPage;